import PropTypes from "prop-types";
import Icon from "@react-native-vector-icons/material-design-icons";
import React, { useContext, useMemo } from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { OrganizationContext } from "webContext/Organization.context";

const classes = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 8,
  },
  checkbox: {
    width: 24,
    height: 24,
    borderWidth: 2,
    borderColor: "#333",
    borderRadius: 4,
    justifyContent: "center",
    alignItems: "center",
    marginRight: 8,
  },
  checkmark: {
    color: "white",
  },
  label: {
    fontSize: 16,
  },
  user: {
    borderWidth: 0,
    backgroundColor: "transparent",
  },
});

export default function Checkbox(props) {
  const { label, checked, onChange, isUser, accessibilityLabel } = props;

  const { organizationColor } = useContext(OrganizationContext);

  const stateClasses = useMemo(
    () =>
      StyleSheet.create({
        checked: {
          borderColor: organizationColor,
        },
      }),
    [organizationColor],
  );

  return (
    <TouchableOpacity
      style={classes.container}
      onPress={() => onChange(!checked)}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
    >
      <View
        style={[
          classes.checkbox,
          isUser ? classes.user : checked && stateClasses.checked,
        ]}
      >
        {isUser ? (
          <Icon
            name={checked ? "check" : "account-multiple-plus-outline"}
            size={25}
            color={organizationColor}
          />
        ) : (
          checked && <Icon name="check" size={25} color={organizationColor} />
        )}
        {label && <Text style={classes.label}>{label}</Text>}
      </View>
    </TouchableOpacity>
  );
}

Checkbox.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  isUser: PropTypes.bool,
  accessibilityLabel: PropTypes.string,
};
